export default __webpack_public_path__ + "static/media/Licence.0aacfe8b.jpg";